import { cn } from "@/lib/utils";

const statusConfig = {
  "cleared": { label: "Cleared", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  "approved": { label: "Approved", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  "complete": { label: "Complete", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  "on-track": { label: "On track", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  "in-progress": { label: "In progress", className: "bg-blue-50 text-blue-700 border-blue-200" },
  "needs-review": { label: "Needs review", className: "bg-amber-50 text-amber-700 border-amber-200" },
  "pending-review": { label: "Pending review", className: "bg-amber-50 text-amber-700 border-amber-200" },
  "pending-match": { label: "Pending match", className: "bg-amber-50 text-amber-700 border-amber-200" },
  "evidence-submitted": { label: "Evidence submitted", className: "bg-blue-50 text-blue-700 border-blue-200" },
  "blocker": { label: "Blocker", className: "bg-red-50 text-red-700 border-red-200" },
  "at-risk": { label: "At risk", className: "bg-red-50 text-red-700 border-red-200" },
  "locked": { label: "Locked", className: "bg-red-50 text-red-700 border-red-200" },
  "not-started": { label: "Not started", className: "bg-slate-100 text-slate-600 border-slate-200" },
  "waiting": { label: "Waiting", className: "bg-slate-100 text-slate-500 border-slate-200" },
  "on-hold": { label: "On hold", className: "bg-slate-100 text-slate-500 border-slate-200" },
  "draft": { label: "Draft", className: "bg-slate-100 text-slate-600 border-slate-200" },
  "sent": { label: "Sent", className: "bg-blue-50 text-blue-700 border-blue-200" },
  "processed": { label: "Processed", className: "bg-slate-100 text-slate-600 border-slate-200" },
  "actioned": { label: "Actioned", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  "pass": { label: "Pass", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  "warning": { label: "Warning", className: "bg-amber-50 text-amber-700 border-amber-200" },
  "fail": { label: "Fail", className: "bg-red-50 text-red-700 border-red-200" },
  "pending-review-pack": { label: "Pending review", className: "bg-amber-50 text-amber-700 border-amber-200" },
};

export function StatusBadge({ status, className: extraClassName, size = "default" }) {
  const config = statusConfig[status] || { label: status, className: "bg-slate-100 text-slate-600 border-slate-200" };

  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center rounded-full border font-medium whitespace-nowrap",
        size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-0.5 text-xs",
        config.className,
        extraClassName
      )}
    >
      {status === "blocker" && <span className="w-1.5 h-1.5 rounded-full bg-red-500 mr-1.5 animate-pulse-dot" />}
      {status === "locked" && <span className="w-1.5 h-1.5 rounded-full bg-red-500 mr-1.5 animate-pulse-dot" />}
      {config.label}
    </span>
  );
}

export function GateStateBadge({ state }) {
  const config = {
    cleared: { label: "Gate Cleared", className: "bg-emerald-50 text-emerald-700 border-emerald-300", dot: "bg-emerald-500" },
    locked: { label: "Gate Locked", className: "bg-red-50 text-red-700 border-red-300", dot: "bg-red-500" },
    "needs-review": { label: "Needs Review", className: "bg-amber-50 text-amber-700 border-amber-300", dot: "bg-amber-500" },
    waiting: { label: "Waiting", className: "bg-slate-100 text-slate-500 border-slate-300", dot: "bg-slate-400" },
  };

  const c = config[state] || config.waiting;

  return (
    <span
      data-testid={`gate-state-${state}`}
      className={cn("inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold", c.className)}
    >
      <span className={cn("w-2 h-2 rounded-full", c.dot, state === "locked" && "animate-pulse-dot")} />
      {c.label}
    </span>
  );
}
